<script>
    import { t } from "../../../../i18n";

    export let data = {};

    let cols = data && data.rates && data.rates.cols;
    let rows = data && data.rates && data.rates.rows;
    let currency = data && data.rates && data.rates.currency;

    let formatMoney = function(amount){
        if(!amount)return '<span style="font-weight: normal; font-size: 0.7em;">-</span>';
        if(!currency) return amount;
        return amount + ' <span class="currency-code" style="font-size:0.7em;">'+currency+'</span>';
    }

</script>


{#if !currency || !rows || !cols }
    <p>
        {$t('rates.unavailable')}
        {$t('rates.retry_prefix')}<a href="/#/contact">{$t('rates.contact_us')}</a>{$t('rates.retry_suffix')}
    </p>

{:else if rows.length}


    <div class="table-responsive">
        <table class="table mb-0">
            <thead class="thead-dark">
            <tr>
                <th>{$t('rates.pax')}</th>
                {#each Object.values(cols) as col}
                <th>{col}</th>
                {/each}
            </tr>
            </thead>
            <tbody>

            {#each rows as row}
                <tr>
                    <td>{row.pax}</td>
                    {#each Object.values(row.cost) as cost}
                        <td>{@html formatMoney(cost)}</td>
                    {/each}
                </tr>
            {/each}

            </tbody>
        </table>

    </div>

{:else}
    {$t('common.no_data')}

{/if}